import { useStore } from "@/store";
import { AuthActionTypes } from "@/store/auth/actions";
import dayjs from "dayjs";

export const login = (email: string, password: string) => {
  const store = useStore();
  return store.dispatch(AuthActionTypes.Login, {
    email,
    password,
  });
}

export const removeAllSpace = (input: string) => {
  return input?.replace(/\s/g, '');
}

export const formatDate = (date: string) => {
  if(!date) return '';
  return dayjs(date?.split("T")[0])?.format('MMM D, YYYY') ?? '';
}

export const formatCurrency = (amount: number) => {
  return "$"+amount+" USD"
}